export default __webpack_public_path__ + "static/media/banner_1_2.f99e4d99.png";